import { PaymentAccount } from '../components/transaction/PaymentAccount';
import { useAccount, useAccountNumber } from '../fetchHooks/useAccount';
import useFavoriteAccount from '../fetchHooks/useFavoriteAccount';
import type { Account } from '../generated-types';
import { getPaymentAccount } from '../services/accountFilters';
import useAccountId from './queryparams/useAccountId';

const usePaymentAccount = (paymentCheck?: (account?: Account) => boolean): PaymentAccount | undefined => {
    const accountId = useAccountId();

    const { data: favoriteAccountNumber } = useFavoriteAccount();

    const { data: currentAccount, isFetched } = useAccount(accountId);
    const { data: favoriteAccount } = useAccountNumber(favoriteAccountNumber);

    const paymentAccount = getPaymentAccount([currentAccount, favoriteAccount], paymentCheck);
    if (isFetched && !paymentAccount) return undefined;
    return paymentAccount;
};
export default usePaymentAccount;
